import { TeamsUserCredential, UserInfo } from "@microsoft/teamsfx";
import { createContext } from "react";
import { Theme } from "@fluentui/react-components";
import { app, HostClientType } from "@microsoft/teams-js";

export const TeamsFxContext = createContext<{
  theme: Theme | undefined;
  themeString: string;
  context: app.Context | undefined;
  teamsUserCredential: TeamsUserCredential | undefined;
  clientType: HostClientType | undefined;
  userInfo: UserInfo | undefined;
}>({
  theme: undefined,
  themeString: "",
  context: undefined,
  teamsUserCredential: undefined,
  clientType: undefined,
  userInfo: undefined,
});
